import { render } from "./removebutton.vue?vue&type=template&id=01200ffe&scoped=true"
import script from "./removebutton.vue?vue&type=script&lang=js"
export * from "./removebutton.vue?vue&type=script&lang=js"

import "./removebutton.vue?vue&type=style&index=0&id=01200ffe&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01200ffe"]])

export default __exports__